import React from 'react'
import styled from '@emotion/styled'
import Link from 'next/link'

export default function Pagination({ page, pageCount }) {
  if (pageCount <= 1) { return null }

  const isFirst = page <= 1
  const isLast = page >= pageCount

  const numbers = []
  if (pageCount <= 5) {
    for (let i = 1; i <= pageCount; i++) { numbers.push(i) }
  } else {
    numbers.push(1)
    if (page > 3) { numbers.push('…') }
    if (page > 2) { numbers.push(page - 1) }
    if (page !== 1 && page !== pageCount) { numbers.push(page) }
    if (page < pageCount - 1) { numbers.push(page + 1) }
    if (page < pageCount - 2) { numbers.push('…') }
    numbers.push(pageCount)
  }

  return (
    <PaginationWrapper>

      {isFirst ? (
        <Arrow disabled aria-disabled='true' aria-label='Previous page'>
          <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden='true'>
            <path d="M10 15L1 7.6959L10 0.999999" stroke="#07218F" />
          </svg>
        </Arrow>
      ) : (
        <Link href={`/blog?page=${page - 1}`} aria-label='Previous page'>
          <Arrow>
            <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden='true'>
              <path d="M10 15L1 7.6959L10 0.999999" stroke="#07218F" />
            </svg>
          </Arrow>
        </Link>
      )}
      {numbers.map((n, idx) =>
        typeof n === 'number' ? (
          <Link
            key={idx}
            href={`/blog?page=${n}`}
          >
            <PageNumber
              key={idx}
              active={n === page}
            >
              {n}
            </PageNumber>
          </Link>
        ) : (
          <Ellipsis key={idx}>{n}</Ellipsis>
        )
      )}
      {isLast ? (
        <Arrow disabled aria-disabled='true' aria-label='Next page'>
          <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden='true'>
            <path d="M1 1.00025L10 8.30434L1 15.0002" stroke="#07218F" />
          </svg>
        </Arrow>
      ) : (
        <Link href={`/blog?page=${page + 1}`} aria-label='Next page'>
          <Arrow>
            <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden='true'>
              <path d="M1 1.00025L10 8.30434L1 15.0002" stroke="#07218F" />
            </svg>
          </Arrow>
        </Link>
      )}
    </PaginationWrapper>
  )
}

const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: center;
  font-family: Euclid, sans-serif;
  margin: 32px 0;

  a {
    text-decoration: none;
  }
`

const PageNumber = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: ${({ active }) => (active ? '#333' : '#000')};
  font-weight: ${({ active }) => (active ? 400 : 700)};

  &:hover {
    opacity: 1;
  }
`

const Ellipsis = styled.span`
  font-size: 18px;
  color: #333;
`

const Arrow = styled.button`
  width: 40px;
  height: 40px;
  border: 1px solid #e5dfd6;
  background: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  color: ${({ disabled }) => (disabled ? '#aaa' : 'tomato')};
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${({ disabled }) => (disabled ? 'none' : '#fafafa')};
  }

  &:disabled {
    cursor: cancel;
  }
`
